import { render } from "./StartAuthComponent.vue?vue&type=template&id=1f668b6f&scoped=true"
import script from "./StartAuthComponent.vue?vue&type=script&lang=js"
export * from "./StartAuthComponent.vue?vue&type=script&lang=js"

import "./StartAuthComponent.vue?vue&type=style&index=0&id=1f668b6f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f668b6f"]])

export default __exports__